import { TableColumn, TableColumnType } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';
import { ASSET_TYPE, IMAGE_ART, PURSUE } from './vkb-form-fields';
export class VKBTableColumnData {
  /* Default table column configurations */
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'checked',
      header: $localize`Checkbox`,
      type: TableColumnType.checkbox,
      class: 'w-[auto] grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
    },
    {
      sequence: 2,
      columnDef: 'previewUrl',
      header: $localize`Asset`,
      type: TableColumnType.assetPreview,
      class: 'w-[13vw] min-w-[9rem] pl-4 grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 3,
      columnDef: 'name',
      header: $localize`Name`,
      class: 'w-[30rem] pl-4',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 4,
      columnDef: '_id',
      header: $localize`ID`,
      type: TableColumnType.name,
      class: 'w-[13vw] min-w-[18rem] pl-4 grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 5,
      columnDef: 'assetType',
      header: $localize`:asset type:Type`,
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 6,
      columnDef: AssetMetadata.General.TAGS,
      type: TableColumnType.tags,
      header: $localize`Tags`,
      class: 'w-[12%] min-w-[12rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 7,
      columnDef: 'status',
      header: $localize`Status`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 8,
      columnDef: 'createdAt',
      type: TableColumnType.date,
      header: $localize`Created at`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 9,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`Created by`,
      class: 'w-[8%] min-w-[6rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 10,
      columnDef: 'expiryDate',
      type: TableColumnType.date,
      header: $localize`Expiry date`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
  ];
  /* Additional columns configurations */
  static ADD_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'customFields',
      header: 'Unternehmen',
      showValue: 'pursue',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: PURSUE,
    },
    {
      sequence: 2,
      columnDef: 'customFields',
      header: 'Datei-Art',
      showValue: 'assetTypeCustom',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: ASSET_TYPE,
    },
    {
      sequence: 3,
      columnDef: 'customFields',
      header: 'Bild-Art',
      showValue: 'imageArt',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: IMAGE_ART,
    },
  ];
}
